import React from 'react';

const EllipseRight = () => {
  return (
    <svg
      width="500"
      height="2688"
      viewBox="0 0 500 2688"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto max-w-none"
    >
      <path
        opacity="0.3"
        d="M2034.49 185.526C1392.77 -184.973 543.401 17.4327 173.387 658.316C-196.627 1299.2 52.7681 2135.98 694.49 2506.47C1336.18 2876.96 2156.35 2657.73 2526.38 2016.82C2896.41 1375.91 2676.18 556.008 2034.49 185.526Z"
        stroke="url(#paint0_linear_12395_21235)"
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12395_21235"
          x1="944.521"
          y1="101.476"
          x2="782.521"
          y2="2535.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#899B30" />
          <stop offset="0.327251" stopColor="#D6CFF8" />
          <stop offset="0.62" stopColor="#3A4B24" />
          <stop offset="1" stopColor="#FBF8F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EllipseRight;